import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, openModal } from "risa-oasis-ui_v2";
import { LoaderMessage } from "../../components/loaderMessage/loaderMessage";
import NewClientModal from "../../components/modals/newClientModal/newClientModal";
import { fetchClientFromFirebase } from "../../redux/slice/clientConfiguration";
import { AppDispatch, RootState } from "../../redux/store/store";
import ClientCardDetails from "./components/ClientCardDetails";
import ClientFacilityCard from "./components/clientFacilityCard";

const ClientConfiguration = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { data: clientData, loading } = useSelector(
    (state: RootState) => state.clientConfiguration,
  );
  const [clientList, setClientList] = useState<any[]>([]);
  const [showNewClientModal, setShowNewClientModal] = useState<boolean>(false);
  const [selectedHealthCareFacilityIndex, setSelectedHealthCareFacilityIndex] =
    useState<number>(0);

  useEffect(() => {
    dispatch(fetchClientFromFirebase());
  }, [dispatch]);

  useEffect(() => {
    if (clientData && !loading) {
      setClientList(clientData);
    } else {
      setClientList([]);
    }
  }, [clientData, loading]);

  useEffect(() => {
    if (showNewClientModal) {
      openModal("new-client-modal");
    }
  }, [showNewClientModal]);

  return (
    <div className="health-facility-config layout flex h-full flex-col gap-4 overflow-hidden">
      {loading ? (
        <>
          <div className="h-full w-full">
            <LoaderMessage message={"Loading health care facilities..."} />
          </div>
        </>
      ) : (
        <>
          <div className="health-facility-config header flex items-center justify-between border-b border-gray-200 pb-2">
            <div className="health-facility-config header text text-h11 font-semibold">
              Client Configuration
            </div>
            <div className="health-facility-config header action">
              <Button
                disabled={false}
                children={"Add New Client"}
                onClick={() => {
                  setShowNewClientModal(true);
                }}
                buttonType={"primary"}
                size={"medium"}
              />
            </div>
          </div>
          <div className="health-facility-config body flex flex-1 gap-4 overflow-hidden">
            <div className="health-facility-config body left b flex flex-1 flex-col gap-4 overflow-auto">
              {clientList.map((client) => (
                <div
                  key={client.DocId ?? ""}
                  onClick={() => {
                    setSelectedHealthCareFacilityIndex(
                      clientList.indexOf(client),
                    );
                  }}
                >
                  <ClientFacilityCard
                    key={client.DocId ?? ""}
                    healthCareData={client}
                    isActive={
                      selectedHealthCareFacilityIndex ===
                      clientList.indexOf(client)
                    }
                  />
                </div>
              ))}
            </div>
            <div className="health-facility-config body right flex-1 overflow-hidden">
              <ClientCardDetails
                singleHealthCareData={
                  clientList[selectedHealthCareFacilityIndex]
                }
              />
            </div>
          </div>
          {showNewClientModal && (
            <NewClientModal
              data={null}
              onModalClose={() => setShowNewClientModal(false)}
              type={"add"}
            />
          )}
        </>
      )}
    </div>
  );
};

export default ClientConfiguration;
